import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4f381c08"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "campaign-name" };
import { useCampaignSummary } from "src/shared/store/campaign-summary/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignName',
    props: {
        campaignId: {}
    },
    setup(__props) {
        const props = __props;
        const { campaignSummary } = useCampaignSummary(() => props.campaignId);
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString((_a = _unref(campaignSummary)) === null || _a === void 0 ? void 0 : _a.name), 1 /* TEXT */));
        };
    }
});
